export default __webpack_public_path__ + "static/media/pv-4.6bebe960.png";